import { Variants } from '../types/variant';

export const mpbVariants = {
  mon_bilan_prevention: {
    name: 'Mon bilan prévention',
    status: 'stable',
    availableInDemo: false,
    description:
      "Mon bilan prévention selon la tranche d'âge tel que préparé par la sécurité sociale.",
    speciality: 'MBP',
    patientOnboarding: 'MON_BILAN_PREVENTION',
    patientOffboarding: 'DIRECT_CONFIRMATION',
    emailTemplate: 'mon-bilan-prevention',
    initialQuestions: [],
    reportTemplate: 'MON_BILAN_PREVENTION',
    pages: {
      CONSULTATION: {
        title: 'Situation personnelle, environnement social et familial',
        sections: ['CONTEXTE', 'SITUATION_PERSONNELLE'],
      },
      ANTECEDENTS: {
        title: 'Vos antécédents personnels et familiaux',
        sections: ['ANTECEDENTS'],
      },
      ETAT_DE_SANTE: {
        title: 'Votre état de santé actuel',
        sections: ['ETAT_DE_SANTE'],
      },
      ACTIVITE_PHYSIQUE_ET_ALIMENTATION: {
        title: 'Activité physique, sédentarité et alimentation',
        sections: ['ACTIVITE_PHYSIQUE_ET_ALIMENTATION'],
      },
      ENVIRONNEMENT: {
        title: 'Logement',
        sections: ['ENVIRONNEMENT'],
      },
      VACCINS_ET_DEPISTAGES: {
        title: 'Vaccins, dépistages et santé sexuelle',
        sections: ['VACCINS_ET_DEPISTAGES'],
      },
      CONDUITES_ADDICTIVES: {
        title:
          'Conduites addictives, consommation de boissons alcoolisées, tabac et autres substances',
        sections: ['CONDUITES_ADDICTIVES'],
      },
      SANTE_MENTALE: {
        title: 'Santé et bien-être mental, violences',
        sections: ['SANTE_MENTALE'],
      },
      THEMES_PRIORITAIRES: {
        title: 'Précisions complémentaires concernant votre santé',
        sections: ['THEMES_PRIORITAIRES'],
      },
      CONCLUSION: { title: 'Conclusion', sections: ['RECAP'] },
    },
    initialAssertions: [
      '[Assertion: #12‹]-(01.DESCR)->[Médecin: #z]-(----)->[Médecin: #]-(rôle)->[Médecin Traitant: #z]-(REL)->[Personne: #x]',
    ],
    options: ['COMPACT', 'ALERTES', 'MON_BILAN_PREVENTION'],
    visitMotive: 'Mon bilan prévention',
  },
} satisfies Variants;
